import { Auth0Provider } from '@auth0/auth0-react';
import { onRedirectCallback } from 'utils/helpers/auth0.helpers';
import { RefreshTokenKeepingCache } from 'utils/helpers/auth0RefreshTokenCache';
import { GlobalStyles, ThemeProvider } from '@mui/material';
import { createRoot } from 'react-dom/client';
import './polyfills';
import theme from 'context/createTheme';
import globalStyles from 'styles/Global';
import App from './App';
import sentryInit from 'utils/sentryCrashReporting';
import { QueryClientProvider } from 'components/QueryClientProvider/QueryClientProvider';

// Sets up sentry for observability
sentryInit();

const refreshTokenCache = new RefreshTokenKeepingCache();

// Route /oauth/token via savi-api so Auth0 does not see the browser Origin and suppress refresh tokens.
const originalFetch = window.fetch.bind(window);
window.fetch = (input: RequestInfo | URL, init?: RequestInit) =>
  String(input).endsWith('/oauth/token')
    ? originalFetch(`${process.env.REACT_APP_SAVI_API_HOST}/api/v2/users/oauth-token`, init)
    : originalFetch(input, init);

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN ?? ''}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID ?? ''}
      authorizationParams={{
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        redirect_uri: window.location.origin,
        scope: 'openid profile email offline_access', // default scopes when using refresh tokens
      }}
      onRedirectCallback={onRedirectCallback}
      cache={refreshTokenCache}
      useRefreshTokens
      useRefreshTokensFallback // if we receive a "Missing/Invalid refresh token" error, redirect to the login page
    >
      <GlobalStyles styles={globalStyles} />
      <ThemeProvider theme={theme}>
        <QueryClientProvider>
          <App />
        </QueryClientProvider>
      </ThemeProvider>
    </Auth0Provider>,
  );
}
